import React, { memo } from 'react';

import Popup from '../helpers/Popup';
import Button from '../helpers/Button';

const MailingInfoSendPopupComponent = ({
  message,
  isSubmitted,
  filesCount,
  uploadedFilesCount,
  onClose,
  onConfirm,
}) => {
  const width = `${(uploadedFilesCount / filesCount) * 100}%`;

  const footer = (
    <>
      <Button className="btn-primary" disabled={isSubmitted} onClick={onConfirm}>
        Ok
      </Button>
      <Button data-dismiss="modal" disabled={isSubmitted} onClick={onClose}>
        Close
      </Button>
    </>
  );

  return (
    <Popup footer={footer} header="Confirm Action" id="mailingInfoSendPopup">
      {isSubmitted && filesCount > 0 ? (
        <div className="progress">
          <div className="progress-bar progress-bar-striped active" role="progressbar" style={{ width }} />
        </div>
      ) : (
        message
      )}
    </Popup>
  );
};

export const MailingInfoSendPopup = memo(MailingInfoSendPopupComponent);
